import { useQuery } from '@tanstack/react-query';
import { threadsApi } from '@/lib/messaging/api';

export function useContactSmsSenderLines(contactId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['contacts', contactId, 'sms-sender-lines'],
    queryFn: () => threadsApi.senderLines(contactId),
    enabled: enabled && Boolean(contactId),
    staleTime: 30_000,
  });
}
